import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";

interface ClosedConversationLabelProps {
  onStartNewChat: () => void;
  onBackToActiveChat?: () => void;
  hasActiveConversation?: boolean;
}

export function ClosedConversationLabel({ 
  onStartNewChat, 
  onBackToActiveChat,
  hasActiveConversation = false 
}: ClosedConversationLabelProps) {
  const { t } = useLanguage();
  return (
    <div className="px-4 py-3 bg-gray-100 border-t border-gray-200 flex items-center justify-center gap-3">
      <p className="text-sm text-gray-600 italic">
        {t("conversationClosed")}
      </p>
      {hasActiveConversation && onBackToActiveChat ? (
        <Button
          onClick={onBackToActiveChat}
          size="sm"
          className="bg-brand-600 hover:bg-brand text-white"
        >
          {t("backToActiveChat")}
        </Button>
      ) : (
        <Button
          onClick={onStartNewChat}
          size="sm"
          className="bg-brand-600 hover:bg-brand text-white"
        >
          {t("startNewChat")}
        </Button>
      )}
    </div>
  );
}